import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse,
  headersWithoutAuthWithoutBody
} from "../../../APIHelpers/Responses";

export const blogPostServices = {
  addNewBlogPost,
  updatedBlogPost,
  softDeleteRestoreBlogPost,
  deleteBlogPost,
  getBlogPostList,
  getPublicBlogPostList,
  getPublicSingleBlogPost,
};

// Add New Blog Post
async function addNewBlogPost(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewBlogPost`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Blog Post
async function updatedBlogPost(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedBlogPost`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Blog Post
async function softDeleteRestoreBlogPost(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreBlogPost`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Blog Post
async function deleteBlogPost(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteBlogPost`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Blog Post
async function getBlogPostList(status, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getBlogPostList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getBlogPostList/${status}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getBlogPostList/${status}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Public Blog Post
async function getPublicBlogPostList(status, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getPublicBlogPostList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getPublicBlogPostList/${status}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getPublicBlogPostList/${status}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithoutAuthWithoutBody("GET"),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Public Single Blog Post
async function getPublicSingleBlogPost(postId) {
  let apiURL = `${config.API_URL_USER_ONBOARDING}getPublicSingleBlogPost/${postId}`;
  const response = await fetch(apiURL, headersWithoutAuthWithoutBody("GET"));
  const result = await response.json();
  const data = decryptResponse(result);
  if (data?.statusCode === 401) {
    handleResponse(data)
  }
  return data;
}